import React, { useState, useEffect } from 'react';
import { useCart } from '@jetshop/core/components/Query/CartProvider';
import CartQuery from '../Cart/CartQuery.gql';
import { Curtain } from '../Curtain/Curtain';
import { useIntl } from '@jetshop/intl';
import { useElevate } from './ElevateContext';
import { ElevateRecommendationsHandler } from './pdp/ElevateRecommendationsHandler';

export const ElevateAddToCartPopup = ({
  isOpen,
  setIsOpen,
  delay = 1300,
  addedProductKey,
  hasVariants
}) => {
  const { getAddToCartPopupProducts } = useElevate();
  const { cart, result: cartQueryResult } = useCart(CartQuery);
  const [addToCartPopupRes, setAddToCartPopupRes] = useState(null);
  const translate = useIntl();

  const productKeyToUse = hasVariants
    ? addedProductKey
    : `${addedProductKey}-default`;

  useEffect(() => {
    if (cartQueryResult.loading || !addedProductKey) return;

    setAddToCartPopupRes(null);

    let cancelled = false;
    let displayTimer;

    const fetchAddToCartPopupProducts = async () => {
      try {
        const addToCartPopupProductsResponse = await getAddToCartPopupProducts({
          pipedCartProductKeys: (cart?.items ?? [])
            .map(item => item.articleNumber)
            .join('|'),
          variantKey: productKeyToUse,
          limit: 4
        });
        if (cancelled) return;

        const show = () => {
          if (!cancelled) {
            setAddToCartPopupRes(addToCartPopupProductsResponse);
          }
        };

        if (delay <= 0) {
          show();
        } else {
          displayTimer = setTimeout(show, delay);
        }
      } catch (e) {
        if (!cancelled) {
          console.error('Elevate add-to-cart popup failed:', e);
          setAddToCartPopupRes(null);
        }
      }
    };
    fetchAddToCartPopupProducts();

    return () => {
      cancelled = true;
      clearTimeout(displayTimer);
    };
  }, [
    cart,
    addedProductKey,
    cartQueryResult.loading,
    delay,
    getAddToCartPopupProducts
  ]);

  const addToCartPopupTitleLabel = translate(
    'Do you have everything you need?'
  );
  if (!addToCartPopupRes) return null;
  return (
    <Curtain
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      showHandle={true}
      showCloseButton={true}
      maxHeight="80dvh"
    >
      <ElevateRecommendationsHandler
        recommendationsLists={addToCartPopupRes?.recommendationLists}
        title={addToCartPopupTitleLabel}
      />
    </Curtain>
  );
};
